module.exports = __webpack_public_path__ + "img/intro_mo_img02.c0cefc5c.png";